module.exports = __webpack_public_path__ + "static/media/Facebook-Icon.2e9cff98.svg";